<template>
  <VModal
    ref="modal"
    modal-classes="max-w-md mx-auto"
    disable-backdrop-click
    @modal:hidden="$emit('closed')"
  >
    <div class="rounded shadow-xs w-full max-w-2xl mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
        <div class="h-10 bg-white pl-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Create Media</h1>
            </div>
            <div class="flex-none">
              <button
                class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                    4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                    4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                    5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div v-if="!loading" class="p-10 space-y-8" :style="{ minHeight: '600px' }">
          <ValidationProvider name="tags" slim vid="tags">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormLabel for="tags"> Tags </BaseFormLabel>
                <VMultiselect
                  v-model="selectedTags"
                  label="name"
                  track-by="id"
                  placeholder="Type to search"
                  open-direction="bottom"
                  :options="tags"
                  :multiple="true"
                  :searchable="true"
                  :clear-on-select="true"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="400"
                  :hide-selected="false"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <MediaUpload
            :account-id="accountId"
            :on-data="appendTags"
            :on-media-uploaded="finishUpload"
          />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import { accountAssetTagsClient } from '@/api/clients';
import MediaUpload from './MediaUpload.vue';

export default {
  name: 'AccountMediaAssetCreateModal',
  components: {
    MediaUpload,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tags: [],
      formData: {
        tags: [],
      },
    };
  },
  computed: {
    selectedTags: {
      get() {
        return this.formData.tags
          .map((tagId) => this.tags.find((tag) => tag.id === tagId))
          .filter((tag) => tag);
      },
      set(tags) {
        this.formData.tags = tags.map((tag) => tag.id);
      },
    },
  },
  created() {
    this.setup();
  },
  methods: {
    limitText(count) {
      return `and ${count} more tags`;
    },
    appendTags(formData) {
      this.formData.tags.forEach((tag) => {
        formData.append('tags[]', tag);
      });

      return formData;
    },
    async setup() {
      try {
        this.loading = true;
        await this.tryFetchAccountAssetTagList();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async tryFetchAccountAssetTagList() {
      try {
        const response = await accountAssetTagsClient.list(this.accountId);

        this.tags = response?.data?.data || [];
      } catch (error) {
        //
      }
    },
    finishUpload() {
      this.$emit('created');
    },
  },
};
</script>
